import { render, staticRenderFns } from "./AdminPaymentSettings.vue?vue&type=template&id=0a267761&scoped=true"
import script from "./AdminPaymentSettings.vue?vue&type=script&lang=js"
export * from "./AdminPaymentSettings.vue?vue&type=script&lang=js"
import style0 from "./AdminPaymentSettings.vue?vue&type=style&index=0&id=0a267761&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a267761",
  null
  
)

export default component.exports